import React from 'react';

function SpinnerSVG(props) {
  return (
    <svg
      fill={props.fill}
      width={props.width}
      height={props.height}
      viewBox={props.viewbox}
      className={props.classes}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Loading spinner</title>
      <defs>
        <clipPath id="clip-path">
          <path
            className="cls-1"
            d="M73.77.59a5,5,0,0,1-1.34,9.91A55.64,55.64,0,0,0,65,10a54.91,54.91,0,1,0,54,44.43,5,5,0,0,1,9.81-1.91A65,65,0,1,1,73.77.59Z"
            style={{ fill: 'none' }}
          />
        </clipPath>
        <clipPath id="clip-path-2">
          <rect
            className="cls-1"
            style={{ fill: 'none' }}
            width="130"
            height="130"
          />
        </clipPath>
        <clipPath id="clip-path-3">
          <rect
            className="cls-1"
            style={{ fill: 'none' }}
            x="-1"
            y="-1"
            width="132"
            height="132"
          />
        </clipPath>
        <linearGradient id="gradient1" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop
            offset="0%"
            style={{ stopColor: '#d3178e', stopOpacity: '1' }}
          ></stop>
          <stop
            offset="5%"
            style={{ stopColor: '#d3178e', stopOpacity: '1' }}
          ></stop>
          <stop
            offset="75%"
            style={{ stopColor: '#ffa300', stopOpacity: '1' }}
          ></stop>
          <stop
            offset="100%"
            style={{ stopColor: '#ffa300', stopOpacity: '1' }}
          ></stop>
        </linearGradient>
        <linearGradient id="gradient2" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop
            offset="0%"
            style={{ stopColor: '#d3178e', stopOpacity: '1' }}
          ></stop>
          <stop
            offset="15%"
            style={{ stopColor: '#d3178e', stopOpacity: '1' }}
          ></stop>
          <stop
            offset="75%"
            style={{ stopColor: '#ffa300', stopOpacity: '0' }}
          ></stop>
          <stop
            offset="100%"
            style={{ stopColor: '#ffa300', stopOpacity: '0.05' }}
          ></stop>
        </linearGradient>
        <linearGradient id="gradient3" x1="0%" y1="100%" x2="0%" y2="0%">
          <stop
            offset="0%"
            style={{ stopColor: '#ffa300', stopOpacity: '1' }}
          ></stop>
          <stop
            offset="15%"
            style={{ stopColor: '#ffa300', stopOpacity: '1' }}
          ></stop>
          <stop
            offset="50%"
            style={{ stopColor: '#ffa300', stopOpacity: '0.3' }}
          ></stop>
          <stop
            offset="100%"
            style={{ stopColor: '#ffa300', stopOpacity: '0.05' }}
          ></stop>
        </linearGradient>
      </defs>
      <g className="cls-2" style={{ clipPath: 'url(#clip-path)' }}>
        <g className="cls-3" style={{ clipPath: 'url(#clip-path-2)' }}>
          <g className="cls-4" style={{ clipPath: 'url(#clip-path-3)' }}>
            <rect
              fill="url(#gradient1)"
              x="0"
              y="0"
              width="66"
              height="132"
              transform="translate(-1 -1)"
            />
            <rect
              fill="url(#gradient2)"
              x="66"
              y="0"
              width="66"
              height="66"
              transform="translate(-1 -1)"
            />
            <rect
              fill="url(#gradient3)"
              x="66"
              y="66"
              width="66"
              height="66"
              transform="translate(-1 -1)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SpinnerSVG;
